import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';
import logo from './logo.png';
import SEO from './components/SEO';
import { generateBreadcrumbSchema } from './utils/structuredData';

export default function PrivacyArabic() {
  const breadcrumbs = [
    { name: 'الرئيسية', url: '/' },
    { name: 'سياسة الخصوصية', url: '/privacy-ar' }
  ];

  return (
    <div className="terms-root" dir="rtl">
      <SEO
        title="سياسة الخصوصية - تعلّم"
        description="تعرف على كيفية حماية تعلّم لبياناتك وخصوصيتك. اقرأ سياسة الخصوصية الشاملة للطلاب والمعلمين على منصتنا التعليمية."
        keywords="سياسة الخصوصية, حماية البيانات, خصوصية المستخدم, خصوصية تعلّم, خصوصية منصة التعليم"
        canonicalUrl="/privacy-ar"
        alternateUrls={{ en: '/privacy', ar: '/privacy-ar' }}
        lang="ar"
        structuredData={generateBreadcrumbSchema(breadcrumbs)}
      />

      <Link to="/signup">
        <img src={logo} alt="Taealam Logo" className="terms-logo" />
      </Link>
      <Link to="/privacy">
        <button className="terms-lang-btn">English</button>
      </Link>
      <div className="terms-content">
        <h1 className="terms-title">سياسة الخصوصية</h1>
        <div className="terms-updated">آخر تحديث: 22 يونيو 2025</div>
        <section>
          <h2>المقدمة</h2>
          <p>توضح سياسة الخصوصية هذه كيف تقوم منصة "تعلّم" بجمع واستخدام بياناتك الشخصية.</p>
        </section>
        <section>
          <h2>البيانات التي نقوم بجمعها</h2>
          <ul>
            <li>الاسم الكامل</li>
            <li>البريد الإلكتروني</li>
            <li>رقم الهاتف</li>
            <li>المرحلة الدراسية</li>
            <li>المواد التي يتم تدريسها</li>
            <li>الصور والشهادات</li>
            <li>سجل الحجز والتواصل</li>
          </ul>
        </section>
        <section>
          <h2>هل تقديم البيانات إلزامي؟</h2>
          <p>نعم، البيانات أساسية لإنشاء الحساب واستخدام المنصة.</p>
        </section>
        <section>
          <h2>مشاركة البيانات</h2>
          <p>تُستخدم المعلومات داخل المنصة فقط لأغراض الحجز والتعليم، ولا تتم مشاركتها مع أي طرف ثالث بدون إذن المستخدم.</p>
        </section>
        <section>
          <h2>مدة الاحتفاظ بالبيانات</h2>
          <p>نحتفظ بالبيانات طالما أن الحساب نشط، ولمدة تصل إلى 10 سنوات بعد إغلاقه لأغراض قانونية.</p>
        </section>
        <section>
          <h2>حقوق المستخدم</h2>
          <ul>
            <li>الوصول إلى بياناتك</li>
            <li>تعديل أو حذف بياناتك</li>
            <li>سحب الموافقة</li>
            <li>الاعتراض على الاستخدام</li>
          </ul>
        </section>
        <section>
          <h2>الأمان</h2>
          <p>نستخدم تدابير لحماية بياناتك، لكن لا يمكن ضمان الأمان الكامل.</p>
        </section>
        <section>
          <h2>ملفات تعريف الارتباط</h2>
          <p>نستخدم الكوكيز لتحسين تجربة المستخدم وتقديم محتوى مناسب.</p>
        </section>
        <section>
          <h2>معلومات التواصل</h2>
          <p>📧 البريد الإلكتروني: <a href="mailto:privacy@taealam.bh">privacy@taealam.bh</a></p>
        </section>
      </div>
    </div>
  );
} 